import Link from 'next/link';
import { ChevronRightIcon } from '@heroicons/react/outline';
import Balancer from 'react-wrap-balancer';
import { Book } from '../../lib/guideBooks';
import { Routes } from '../../util/routes';
import { CommunityRegisterButton } from '../CommunityRegisterButton';
import { BookCover } from './BookCover';
import { BookSocial } from './BookSocial';

type Props = {
  book: Book;
};

export const AccessScreen = ({ book }: Props) => {
  const { title, contentCollection } = book;

  return (
    <div className="container grid h-full grid-rows-1 lg:grid-cols-2">
      <div className="col flex flex-col-reverse px-4 md:flex-row lg:px-0">
        <div className="my-8 flex-grow pr-8 md:my-14">
          <BookSocial title={title} />

          <h2 className="h2 mt-6 mb-5">
            <Balancer ratio={0.6}>{title}</Balancer>
          </h2>

          <h5 className="h5 mb-4">In this guide</h5>

          <ul className="chapter-list">
            {contentCollection.items.map((chapter) => {
              return (
                <li key={chapter.title} className="mb-2 flex">
                  <ChevronRightIcon
                    className="icon mr-2 flex-shrink-0 text-black/50"
                    strokeWidth={3}
                  />
                  <p className="p-small">{chapter.displayTitle}</p>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="col bg-black/5">
        <div className="m-auto my-14 flex flex-col items-center px-20">
          <BookCover book={book} className="mb-8" />

          <h4 className="h4 mb-3 text-center">
            Join community to get the guide
          </h4>

          <p className="p-small mb-4 text-center">
            Gain free access to all of the contractors guidebooks, blog articles
            and jobs.{' '}
            <Link
              href={Routes.community()}
              className="text-brand-primary hover:underline"
            >
              Learn more
            </Link>
            .
          </p>

          <CommunityRegisterButton label="Get the guide" />
        </div>
      </div>
    </div>
  );
};
